import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { userHasFeature } from '../../../../helpers/Features';

import AdminRoles from '../../../../containers/Admin/Roles';
import AdminRoleEdit from '../../../../containers/Admin/RoleEdit';
import UpgradeBoard from '../../../UpgradeBoard';

const SettingsRolesContent = (props) => {
  const { activeSubTab } = props;
  const { roleId } = useParams();

  if (!userHasFeature('custom-roles')) return <UpgradeBoard feature="custom-roles" />;

  if (!activeSubTab && !roleId) return <AdminRoles />;

  if (activeSubTab === 'add' || roleId) return <AdminRoleEdit />;

  return null;
};

SettingsRolesContent.propTypes = {
  activeSubTab: PropTypes.string,
};

SettingsRolesContent.defaultProps = {
  activeSubTab: null,
};

export default SettingsRolesContent;
